<template>
  <div class="flex items-center justify-center">
    <swiper pagination loop :autoplay="{ delay: 30000 }" class="w-full h-full">
      <swiper-slide class="grid grid-cols-2 grid-rows-2 disclaimer">
        <div class="relative row-span-full">
          <img src="images/Stocksy_967609.jpg" srcset="images/Stocksy_967609.jpg 1440w, images/Stocksy_967609@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover object-right w-full h-full">
        </div>

        <div v-bg-image="'images/josefin-WS5yjFjycNY-unsplash-lightgreen.jpg'" class="grid p-16 space-y-8 text-center text-white bg-cover place-items-center">
          <div class="max-w-md space-y-8 place-items-center">
            <h1 class="text-3xl font-bold uppercase">
              PRIORITY<br>
              LOUNGE
            </h1>
          </div>
        </div>
        <div class="grid p-8 space-y-8 text-center text-white bg-cover xl:p-16 bg-secondary-500 place-items-center">
          <div class="max-w-sm space-y-4 xl:space-y-8 place-items-center">
            <h1 class="text-3xl font-bold uppercase">
              เอกสิทธิ์เพื่อลูกบ้านคนสำคัญ
            </h1>
            <h2 class="text-xl xl:text-2xl">
              ด้วยบริการห้องรับรองสุดพิเศษ<br>
              ให้คุณและครอบครัวได้ผ่อนคลาย
            </h2>
            <p class="text-sm xl:text-base">
              ด้วยบริการเครื่องดื่ม อาหารว่าง และ Free Wifi<br>
              ที่ Sales Gallery เซ็นทรัลพลาซา ระยอง ชั้น 3<br>
              เพียงแสดงสิทธิ์ผ่าน CPN Residence Payment Card*
            </p>
            <p class="text-sm font-bold xl:text-lg">
              หนึ่งในสิทธิประโยชน์พิเศษจาก<br>
              CPN RESIDENCE FAMILY
            </p>
            <div class="absolute bottom-0 right-0 p-4 text-xs">
              *เงื่อนไขเป็นไปตามที่บริษัทฯกำหนด
            </div>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="flex items-center justify-center">
        <div class="space-y-4 text-center">
          <img src="@/assets/logo-the1.svg" class="w-32 mx-auto" alt="The One">
          <p class="py-8 text-4xl text-secondary-500">
            <strong>สิทธิพิเศษสำหรับลูกบ้านคนสำคัญเช่นคุณ</strong><br>
            รับคะแนน <strong>เซ็นทรัล เดอะวัน x 3</strong> เพิ่มคะแนนเป็น <strong>3 เท่า</strong>
          </p>
          <div class="w-full h-0 max-w-screen-xl border-t border-escent" />
          <p>
            จากทุกค่าใช้จ่ายการจอง การทำสัญญา และการผ่อนดาวน์ทุกงวด ทุกโครงการจาก CPN Residence<br>
            (ยอดการใช้จ่าย 25 บาท รับคะแนน เซ็นทรัล เดอะวัน 3 คะแนน จากปกติ 1 คะแนน)<br>
            ให้คุณเปลี่ยนคะแนนสะสมเป็นส่วนลดสำหรับทุกการใช้จ่าย*<br>
            <span class="text-2xl font-bold text-secondary-500">หนึ่งในสิทธิประโยชน์พิเศษจาก CPN RESIDENCE Family</span>
          </p>
          <div class="w-full h-0 max-w-screen-xl border-t border-escent" />
        </div>
        <div class="absolute top-0 left-0 p-12 py-16 text-3xl font-bold text-center text-white xl:p-16 xl:py-24 w-96 bg-secondary-500">
          CPN RESIDENCE PRIVILEGE
        </div>
        <div class="absolute bottom-0 right-0 p-4 text-xs">
          *เงื่อนไขเป็นไปตามที่บริษัทฯกำหนด
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'Privileges',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>
